import $apiJSON from '../http/apiJSON'

// Tourism API Service

export async function getTours(params = {}) {
  return $apiJSON.get('tourism/tours/', { params })
}

export async function getTour(slug) {
  return $apiJSON.get(`tourism/tours/${slug}/`)
}

export async function getTourCategories() {
  return $apiJSON.get('tourism/categories/')
}

export async function getTourDestinations(params = {}) {
  return $apiJSON.get('tourism/destinations/', { params })
}

export async function getTourGuides(params = {}) {
  return $apiJSON.get('tourism/guides/', { params })
}

// Расписание туров
export async function getTourSchedules(tourId) {
  return $apiJSON.get(`tourism/tours/${tourId}/schedules/`)
}

export async function getTourSchedule(scheduleId) {
  return $apiJSON.get(`tourism/schedules/${scheduleId}/`)
}

// Бронирование туров
export async function bookTour(slug, data) {
  return $apiJSON.post(`tourism/tours/${slug}/book/`, data)
}

// Алиас для совместимости с новым компонентом
export async function registerForTour(tourId, data) {
  return $apiJSON.post(`tourism/tours/${tourId}/register/`, data)
}

export async function cancelTourRegistration(registrationId) {
  return $apiJSON.delete(`tourism/registrations/${registrationId}/`)
}

// Регистрации пользователя
export async function getMyTourRegistrations() {
  return $apiJSON.get('tourism/my-registrations/')
}

export async function getMyTourBookings() {
  return $apiJSON.get('tourism/bookings/')
}

export async function getTourBooking(id) {
  return $apiJSON.get(`tourism/bookings/${id}/`)
}

export async function cancelTourBooking(id) {
  return $apiJSON.post(`tourism/bookings/${id}/cancel/`)
}

// Отзывы
export async function getTourReviews(slug) {
  return $apiJSON.get(`tourism/tours/${slug}/reviews/`)
}

export async function addTourReview(slug, data) {
  return $apiJSON.post(`tourism/tours/${slug}/review/`, data)
}

export async function getTourReviewsList(params = {}) {
  return $apiJSON.get('tourism/reviews/', { params })
}

export async function updateTourReview(id, data) {
  return $apiJSON.put(`tourism/reviews/${id}/`, data)
}

export async function deleteTourReview(id) {
  return $apiJSON.delete(`tourism/reviews/${id}/`)
}

// Планы туров
export async function getTourPlan(tourId) {
  return $apiJSON.get(`tourism/tours/${tourId}/plan/`)
}

// Поиск и фильтрация
export async function getToursByCategory(categoryId, params = {}) {
  return $apiJSON.get('tourism/tours/', { params: { category: categoryId, ...params } })
}

export async function getToursByDestination(destinationId, params = {}) {
  return $apiJSON.get('tourism/tours/', { params: { destination: destinationId, ...params } })
}

export async function getUpcomingTours() {
  return $apiJSON.get('tourism/tours/', { 
    params: { 
      start_date__gte: new Date().toISOString().split('T')[0],
      ordering: 'start_date'
    } 
  })
}

export async function getPopularTours() {
  return $apiJSON.get('tourism/tours/', { params: { ordering: '-bookings_count' } })
}

export async function searchTours(query) {
  return $apiJSON.get('tourism/tours/', { params: { search: query } })
}

export async function getToursByPriceRange(minPrice, maxPrice) {
  return $apiJSON.get('tourism/tours/', { 
    params: { 
      min_price: minPrice, 
      max_price: maxPrice 
    } 
  })
}

export async function getToursByDuration(minDuration, maxDuration) {
  return $apiJSON.get('tourism/tours/', { 
    params: { 
      min_duration: minDuration, 
      max_duration: maxDuration 
    } 
  })
}

export async function getToursByDateRange(dateFrom, dateTo) {
  return $apiJSON.get('tourism/tours/', { 
    params: { 
      date_from: dateFrom, 
      date_to: dateTo 
    } 
  })
}

export async function getTourismStats() {
  return $apiJSON.get('tourism/stats/')
}

// Дополнительные функции
export async function checkTourAvailability(tourId, date) {
  return $apiJSON.get(`tourism/tours/${tourId}/availability/`, {
    params: { date }
  })
}

export async function getTourImages(tourId) {
  return $apiJSON.get(`tourism/tours/${tourId}/images/`)
}

export async function addToTourFavorites(tourId) {
  return $apiJSON.post(`tourism/tours/${tourId}/favorite/`)
}

export async function removeFromTourFavorites(tourId) {
  return $apiJSON.delete(`tourism/tours/${tourId}/favorite/`)
}

export async function getFavoriteTours() {
  return $apiJSON.get('tourism/favorites/')
}